import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=85abcaa8&scoped=true&"
import script from "./LeadsTable.vue?vue&type=script&lang=js&"
export * from "./LeadsTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=85abcaa8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85abcaa8",
  null
  
)

export default component.exports